/**
 * AI Search Configuration
 * Central configuration for AI search integration
 */

window.aiSearchConfig = {
  // API Configuration
  api: {
    baseUrl:
      "https://intelligence-api.pleiades.solutions/api/store-search",
    productSearchBaseUrl:
      "https://intelligence-api.pleiades.solutions/api/product-comparison",
    searchEndpoint: "",
    timeout: 1200, // milliseconds before falling back to native Shopify results
  },

  // Cache Configuration
  cache: {
    enabled: true,
    ttl: 5 * 60 * 1000, // 5 minutes in milliseconds
    maxSize: 50, // Maximum number of cached queries
  },

  // Search Results Configuration
  search: {
    // Number of results to fetch from AI API
    resultsPerPage: {
      predictiveSearch: 5, // In search bar dropdown
      searchPage: 6, // On full search results page
    },

    // Default sort options
    defaultSort: "relevance", // 'relevance', 'price', 'name'
    defaultOrder: "asc", // 'asc', 'desc'

    // Minimum query length to trigger AI search
    minQueryLength: 1,

    // Native Shopify results stay visible if the backend does not answer before these deadlines
    predictiveTimeout: 900,
    searchPageTimeout: 1200,
  },

  // UI Configuration
  ui: {
    // Labels and text
    aiSectionHeading: "AI-Powered Suggestions",
    aiResultBadge: "AI Match",
    aiSectionLabel: "AI-Powered Product Suggestions",

    // Show/hide AI results
    showAIResults: true,
    showAIBadge: true,
    showAIHeading: true,

    // Styling
    enableAIStyles: true,
  },

  // Retry Configuration
  retry: {
    maxAttempts: 0,
    backoffMultiplier: 2, // Exponential backoff: 2^attempt * 1000ms
    initialDelay: 1000, // milliseconds
  },

  // Feature Flags
  features: {
    enablePredictiveAI: true, // AI in search bar dropdown
    enableSearchPageAI: true, // AI in full search results page
    enableRandomProducts: false, // Show random products when search is empty
    enableAutoRetry: true, // Automatic retry on API errors
  },

  // Logging
  logging: {
    enabled: true,
    logSearchQueries: false, // Privacy: set to false in production
    logAPIErrors: true,
    logCacheHits: false,
  },

  // Performance Monitoring
  monitoring: {
    trackAPILatency: false,
    trackCacheHitRate: false,
  },
};

/**
 * Helper function to get config value with fallback
 */
window.getAISearchConfig = (path, defaultValue) => {
  const keys = path.split(".");
  let value = window.aiSearchConfig;

  for (const key of keys) {
    if (value && typeof value === "object" && key in value) {
      value = value[key];
    } else {
      return defaultValue;
    }
  }

  return value;
};

/**
 * Helper function to set config value
 */
window.setAISearchConfig = (path, value) => {
  const keys = path.split(".");
  const lastKey = keys.pop();
  let obj = window.aiSearchConfig;

  for (const key of keys) {
    if (!(key in obj)) {
      obj[key] = {};
    }
    obj = obj[key];
  }

  obj[lastKey] = value;
};

// Log configuration on load (if enabled)
if (window.aiSearchConfig.logging.enabled && typeof console !== "undefined") {
  console.debug("AI Search Configuration loaded:", window.aiSearchConfig);
}
